// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface QuoteProps {
    bgColor?: 'green' | 'beige'
    text: string
    image: string
    alt: string
    name: string
    position?: string
}

export default function Quote({
    bgColor,
    text,
    image,
    alt,
    name,
    position
}: QuoteProps) {
    return (
        <Section
            textColor='text-dark'
            className='quote-component'
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
        >
            <div className='grid-container'>
                <div className='grid-row'>
                    <div className='c-lg-10 start-lg-2'>
                        <div className='quote-component__wrapper'>

                            <div
                                className={clsx(
                                    'text-left',
                                    bgColor === 'beige' && 'text-left--beige',
                                    bgColor === 'green' && 'text-left--green'
                                )}
                                dangerouslySetInnerHTML={{ __html: text }}
                                suppressHydrationWarning
                            ></div>

                            <div className='right-infos'>

                                {image && (
                                    <div className='image'>
                                        <Image
                                            src={image} // 300x300
                                            alt={alt}
                                            className='cover'
                                        />
                                    </div>
                                )}

                                {isNonWhitespaceString(name) && (
                                    <p className={clsx(
                                        'text-md name',
                                        !image && 'name--no-image'
                                    )}>
                                        {name}
                                    </p>
                                )}

                                {isNonWhitespaceString(position) && (
                                    <p className='position'>
                                        {position}
                                    </p>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

